export type Step =
  | 'Intro'
  | 'Second'
  | 'Third'
  | 'Lulu'
  | 'Saks'
  | 'Saks2'
  | 'Sephora'
  | 'Final'
  | 'VS';

export interface Scavenger {
  id: string;
  currentStep: Step;
}

export const StepOrder: Step[] = [
  'Intro',
  'Second',
  'Third',
  'Lulu',
  'Sephora',
  'VS',
  'Final',
];
